// Utility function that connects with AI and streams result back to onDataChunk routine
export const getAIReplyStream = async (courseId, update_comment_details, onDataChunk) => {
    
    const server_address = process.env.REACT_APP_SERVER_ADDRESS;
    console.log(server_address)

    const response = await fetch(`${server_address}/comment/${courseId}/streamAI`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('profile'))?.token}`,
      },
      body: JSON.stringify(update_comment_details),
    });
  
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
  
    let result = "";
  
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
  
      const chunk = decoder.decode(value, { stream: true });
      result += chunk;
      onDataChunk(chunk); // invoke a callback to update the UI as chunks arrive
    }
  
    return result;
  };
